import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from '../Dashboard/index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { addNewColor, editColor, getAllColors } from "../../../redux/features/colors/colorsService";
import { showToast } from "../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark, faXmark } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import SearchBar from "../../../components/SearchBar";
import TableSkeleton from "../../../components/Skeleton";
import { editCustomerRequest, getAllCustomerRequests } from "../../../redux/features/customerRequests/customerRequestsService";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { getStaffMembers } from "../../../redux/features/staff/staffService";

const statusList = [
    { id: '1', name: 'PENDING', order: 1 },
    { id: '2', name: 'INPROGRESS', order: 2 },
    { id: '3', name: 'COMPLETED', order: 3 },
]
const CustomerRequests = () => {

    const dispatch = useDispatch();
    const staffDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);

    const { isCustomerRequestsLoading, pageCount, customerRequests } = useSelector((state) => state.customerRequest.allCustomerRequests);
    const { isEditingCustomerRequest, customerRequestEditedMsg } = useSelector((state) => state.customerRequest.editedCustomerRequest);
    const { isLoading, staff } = useSelector((state) => state.staff.staffMembers);

    const [skip, setSkip] = useState(0);

    const limit = 10;  // Number of items per page
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);

    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedStaffMember, setSelectedStaffMember] = useState({ id: '', name: '' });
    const [selectedStatus, setSelectedStatus] = useState({ id: '', name: '' });
    const [filteredStatusList, setFilteredStatusList] = useState([]);

    const fetchAllCustomerrequests = useCallback(() => {
        dispatch(getAllCustomerRequests({
            skip: skip,
            limit,
            search: searchQuery
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        fetchAllCustomerrequests();
        dispatch(getStaffMembers({}));
    }, [fetchAllCustomerrequests, dispatch]);

    const handleStaffSelect = (option) => {
        setSelectedStaffMember({
            id: option.id,
            name: option.name
        });
    }

    const handleStatusSelect = (option) => {
        setSelectedStatus({
            id: option.id,
            name: option.name
        });
    }

    const updateDetails = async () => {
        if (selectedStaffMember.name !== '') {
            try {
                const data = {
                    id: selectedRequest.id,
                    agent_id: +selectedStaffMember.id
                }
                const response = await dispatch(editCustomerRequest(data)).unwrap();
                setEditBtnDisable(false);
                setSelectedRequest(null);
                setModalOpen(false);
                showToast('success', response.message);
                fetchAllCustomerrequests();
            }
            catch (error) {
                setEditBtnDisable(false);
                showToast('error', error.message);
            };
        }
    };

    //Activate Color
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);

    const handleStatus = async () => {
        setActivateModalOpen(false);
        try {
            const data = {
                id: selectedRequest.id,
                status: selectedStatus.name
            }
            const response = await dispatch(editCustomerRequest(data)).unwrap();
            showToast('success', response.message);
            fetchAllCustomerrequests();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    // Pagination
    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    return (
        <div className={`card-section`}>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Customer Requests</h1>
                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                </div>
                <div className={`search-card-body`}>
                    {isCustomerRequestsLoading ?
                        <TableSkeleton columns={["Name", "Email", "Phone Number", "Country", "Status", "Actions"]} rowCount={10} height={20} />
                        : customerRequests.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Name</th>
                                            <th>Email</th>
                                            <th>Phone Number</th>
                                            <th>Country</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {customerRequests?.map((request) => (
                                            <tr key={request.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {request.name}
                                                </td>
                                                <td>{request.email}</td>
                                                <td>{request.phone_number}</td>
                                                <td>{request.country}</td>
                                                <td>{request.status}</td>
                                                <td className={`actionsBtn`}>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        setSelectedRequest(request);
                                                        setEditBtnDisable(false);
                                                        setErrorMsg(null);
                                                        setModalOpen(true);
                                                    }}>Assign</button>
                                                    <button
                                                        className={`btn-edit-label`}
                                                        onClick={() => {
                                                            setSelectedRequest(request);
                                                            setSelectedStatus({ id: '', name: request.status });
                                                            const currentStatus = statusList.find(status => status.name === request.status);
                                                            const nextStatuses = statusList.filter(status => status.order > (currentStatus?.order || 0));
                                                            setFilteredStatusList(nextStatuses);
                                                            setActivateModalOpen(true);
                                                        }
                                                        }>Update Status</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Update Request</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div className={styles.formContainer}>
                                <form
                                    className={styles.coordinatorForm}
                                    noValidate
                                >
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Asign Agent
                                            </label>
                                            <Dropdown
                                                ref={staffDropdownRef}
                                                options={staff.map((member) => ({ id: member.id, name: member.full_name }))}
                                                placeholder="Choose an Option"
                                                onSelect={handleStaffSelect}
                                                value={selectedStaffMember?.name}
                                            />
                                            {errorMsg && (
                                                <p className={`text-danger`}>{errorMsg}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={updateDetails}
                                    >
                                        {isEditingCustomerRequest ? <BeatLoader color='#ffffff' /> : `Save`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isActivateModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Update Status</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setActivateModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div className={styles.formContainer}>
                                <form
                                    className={styles.coordinatorForm}
                                    noValidate
                                >
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Status Update
                                            </label>
                                            <Dropdown
                                                ref={statusDropdownRef}
                                                options={filteredStatusList}
                                                placeholder="Choose an Option"
                                                onSelect={handleStatusSelect}
                                                value={selectedStatus?.name}
                                            />
                                            {errorMsg && (
                                                <p className={`text-danger`}>{errorMsg}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={handleStatus}
                                    >
                                        {isEditingCustomerRequest ? <BeatLoader color='#ffffff' /> : `Save`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default CustomerRequests;
